import {obtenerConsecutivo} from "../../Servicios/BD/Consecutivos/obtenerConsecutivo";
import {subirImagenHostingFile} from "../../Servicios/AlmacenamientoHosting/subirImagenHostingFile";
import {crearHash} from "../Funciones/crearHash";
import {registrarMovimiento} from "../Movimientos/registrarMovimiento";
import {adap_deposito_mov} from "../Adaptadores/adap_deposito_mov";
import {guardarDoc} from "../../Servicios/BD/guardarDoc";
import {aumentarConsecutivo} from "../../Servicios/BD/Consecutivos/aumentarConsecutivo";

export const crearDeposito = async ({entidad, iniciarCarga, usuario,terminar, nuevoAviso}) => {

    iniciarCarga('Subiendo Datos')
    entidad.fecha = new Date().getTime()
    entidad.idUsuario = usuario.id
    entidad.nombre = usuario.nombre
    entidad.codigoUsuario = usuario.codigo
    entidad.correo = usuario.correo

    let consecutivo = await obtenerConsecutivo({col: 'consecutivos', id: 'movimientos'})
    entidad.consecutivo = consecutivo.data

    nuevoAviso({aviso: 'Subiendo captura de pantalla'})
    let img = await subirImagenHostingFile(entidad.img)
    entidad.img = img.data
    entidad.hashString = JSON.stringify(entidad)
    entidad.hash = crearHash({text: entidad.hashString})
    entidad.estado = 'Validando'

    nuevoAviso({aviso: 'Subiendo datos'})
    let doxTrans = await registrarMovimiento({movimiento: adap_deposito_mov(entidad), estado: 'Validando'})
    if (doxTrans) {

        entidad.idMovimiento = doxTrans
        let dox = await guardarDoc('depositos', entidad)
        if (dox.res) {
            await aumentarConsecutivo({col: 'consecutivos', id: 'movimientos', actual: entidad.consecutivo})
            terminar({aviso: 'Deposito subido con exito, ahora esta en estado de validacion'})
        } else {
            terminar({
                aviso: 'Algo inesperado paso, comunicate con soporte con este codigo: 01DEP',
                variante: 'Error'
            })
        }

    } else {
        terminar({aviso: 'Algo inesperado paso, comunicate con soporte con este codigo: 01TRA', variante: 'Error'})
    }
}